import { render, staticRenderFns } from "./welcome-to-aloware.vue?vue&type=template&id=06cd21ae"
import script from "./welcome-to-aloware.vue?vue&type=script&lang=js"
export * from "./welcome-to-aloware.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports